/**
 * 配置的生效方式（服务端 src/game/config-refresh.ts）：发布 / 设为生效时选，决定在线玩家多快用上这一版。
 * 设计稿里叫 instant 的那一项，接口值是 immediate。
 */
export const REFRESH_MODES = ["normal", "immediate", "force"] as const;
export type RefreshMode = (typeof REFRESH_MODES)[number];

export const REFRESH_MODE_TONE: Record<RefreshMode, "info" | "warning" | "danger"> = {
  normal: "info",
  immediate: "warning",
  force: "danger",
};

export function asRefreshMode(v: unknown): RefreshMode | null {
  return (REFRESH_MODES as readonly unknown[]).includes(v) ? (v as RefreshMode) : null;
}
